import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

type Props = {
    isRtl?: boolean;
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    placeHolderString: string;
    className?: string;
}

export default function BulkSearchField({
    isRtl = false,
    searchTerm,
    setSearchTerm,
    placeHolderString,
    className
}: Props) {
    return (
        <div className={cn("relative", className)}>
            <Search
                className="absolute top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 dark:text-slate-500 z-10"
                style={{
                    insetInlineStart: '0.75rem',
                }}
            />
            <Input
                value={searchTerm}
                type="text"
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={placeHolderString}
                dir={isRtl ? 'rtl' : 'ltr'}
                className={cn(
                    "h-11 w-full",
                    "bg-white dark:bg-slate-800",
                    "border-slate-300 dark:border-slate-600",
                    "focus:border-[var(--color-accent)] dark:focus:border-[var(--color-accent)]",
                    "focus:ring-2 focus:ring-[var(--color-accent)]/20",
                    "text-slate-900 dark:text-slate-50",
                    "placeholder:text-slate-400 dark:placeholder:text-slate-500",
                    "rounded-lg",
                    "transition-all duration-200",
                    "shadow-sm hover:shadow-md"
                )}
                style={{
                    paddingInlineStart: '2.5rem',
                    paddingInlineEnd: '1rem',
                    textAlign: 'start',
                }}
            />
        </div>
    )
}
